// extracted by mini-css-extract-plugin
module.exports = {"main":"ModalBody-styles_main__3oyYn","row":"ModalBody-styles_row__3Q36x"};